import { ApolloClient, ApolloLink, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { toast } from 'react-toastify';
import { authConfig } from 'shared-ui/lib/config/auth.config';
import { parseGraphqlErrors } from 'shared-ui/lib/utils/get-gql-error';
import { GraphQLError } from 'graphql'

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.forEach(({ message, locations, path }) => {
      const error = `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`;
      if(message !== "Unauthorized"){
        toast.error(parseGraphqlErrors(graphQLErrors as GraphQLError[]));
      }
      // eslint-disable-next-line no-console
      console.log(error);
    });
  if (networkError) {
    const error = `[Network error]: ${networkError}`;
    // eslint-disable-next-line no-console
    console.log(error);
  }
});

const host = process.env.REACT_APP_API_URL;

const uri = `${host}/graphql`;

const httpLink = createHttpLink({
  uri,
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem(authConfig.tokenStorageKey);
  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : '',
    },
  };
});

const apolloClient = new ApolloClient({
  link: ApolloLink.from([errorLink as ApolloLink, authLink.concat(httpLink)]),
  cache: new InMemoryCache(),
  defaultOptions: {
    mutate: {
      errorPolicy: 'all',
    },
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'ignore',
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
  },
});

export default apolloClient;
